export default __webpack_public_path__ + "6eb4d93803daac7ac07062c5c289bcfa.png";